import { useEffect } from 'react';

import { useQuery, QueryResult } from '@apollo/client';
import { captureException } from '@sentry/browser';

import { BasePageDataQuery, PageType } from '../../types/__generated__';
import { PageMetaContext } from '../context/PageMetaContext';
import basePage from '../server/basePage.gql';
import { useNotNullableContext } from './useNotNullableContext';

export default function useBasePageQuery(): QueryResult<BasePageDataQuery> {
  const { pageType, pageShortName, isPreview } = useNotNullableContext(
    PageMetaContext,
  );
  const result = useQuery<BasePageDataQuery>(basePage, {
    variables: {
      type: pageType.toUpperCase(),
      slug: pageShortName,
      preview: isPreview,
      includeEvent:
        pageType.toUpperCase() === PageType.Fundraising ||
        pageType.toUpperCase() === PageType.InMemory,
    },
    ssr: true,
  });

  useEffect(() => {
    if (result.error) {
      captureException(result.error);
    }
  }, [result.error]);

  return result;
}
